/* unplugin-vue-components disabled */import { render } from "./Logical2DQuestionEditor.vue?vue&type=template&id=08f1dec1&scoped=true"
import script from "./Logical2DQuestionEditor.vue?vue&type=script&lang=js"
export * from "./Logical2DQuestionEditor.vue?vue&type=script&lang=js"

import "./Logical2DQuestionEditor.vue?vue&type=style&index=0&id=08f1dec1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f1dec1"]])

export default __exports__